exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v-317b8531 .icon {\n    width: 150px;\n    height: 150px;\n    background-size: cover;\n    margin: 20px auto;\n}\n.v-317b8531 h1 {\n    color: #666;\n    text-align: center;\n    font-size: 40px;\n    margin-bottom: 20px;\n}\n.v-317b8531 p {\n    text-align: center;\n}\n.v-317b8531 main {\n    display: block;\n    width: 70%;\n    margin: 0 auto;\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/apps/props.vue
 ** module id = 85
 ** module chunks = 0
 **/